module.exports = __webpack_public_path__ + "img/arch-planning.b2c5bbd9.webp";